<script lang="ts">
import entityPanel from '@nuxtDatakodeUtils/components/i3p/panels/entity-panel.vue'
import { I3pEventsEnum } from '@nuxtDatakodeUtils/types/I3pEvents.enum'
import EntityHistorique from './entity/EntityHistorique.vue'
import EntityGlobalInfo from './entity/EntityGlobalInfo.vue'
import CommuneSelector from '~/components/I3pComponent/entity/organizations/index.vue'
import EntityDownloadFile from '~/components/I3pComponent/entity/EntityDownloadFile.vue'

type CommandData = PildomModules.Majic.Data.CommandData

// noinspection JSUnusedGlobalSymbols
export default {
    name: 'CommandEntityPanel',
    components: { EntityGlobalInfo, EntityHistorique, CommuneSelector, EntityDownloadFile },
    extends: entityPanel,
    emits: ['updateMapPosition'],
    data() {
        const tmpData: (CommandData | null) = null
        return {
            tmpData,
        }
    },
    computed: {
        commandData(): CommandData | null {
            return this.entity?.data
        },
    },
    mounted() {
        this.i3pService.emitter
            .on(I3pEventsEnum.geometryChanged, (event: { geometry: any[] }) => {
                // update geometry data when geometry is change din map panel
                this.updateData({ geometry: event.geometry })
            })
    },
    methods: {
        copyEntityLink() {
            if (process.client && this.commandData?.url) {
                navigator.clipboard.writeText(this.commandData?.url)
                this.$showToaster({ text: 'Lien copié', title: '', color: 'info', icon: 'mdi-content-copy' })
            }
        },
        routerPushEntity(k: string | null) {
            if (k) {
                this.$router.push(`${this.baseUrl}/${k}`)
                return
            }
            this.$router.push(`${this.baseUrl}/creation`)
        },
        async saveEntity() {
            this.v$.$touch()
            this.v$.$validate()
            if (this.v$.$error) {
                const msg = `Veuillez renseigner les champs obligatoires.`
                console.warn('validation fail', this.v$.$errors)

                this.$showToaster({
                    text: msg,
                    color: 'warning',
                    icon: 'mdi-alert-circle',
                })
            }
            else if (this.entity?.data?.communes?.length === 0) {
                this.$showToaster({
                    text: `Veuillez renseigner au moins une commune.`,
                    color: 'warning',
                    icon: 'mdi-alert-circle',
                })
            }
            else {
                if (this.entity?.data.k) {
                    this.i3pService.isSaving = true
                    await this.i3pService.updateEntity(this.entity)
                    this.i3pService.isSaving = false
                    await this.i3pService.showEntity(this.entity.data.k)
                    this.setEditMode(false)
                }
                else {
                    this.i3pService.isSaving = true
                    const entity = await this.i3pService.storeEntity(this.entity)
                    this.i3pService.currentEntityK = null
                    this.i3pService.isSaving = false
                    await this.i3pService.showEntity(entity?.data?.k)
                    this.setEditMode(false)
                }
            }
        },
        async renewCommand() {
            this.i3pService.renewCommand(this.commandData)
            this.tmpData = this.commandData
            await this.i3pService.createEntity()
            const fielsName = ['name', 'matrice_type', 'communes']
            fielsName.forEach((field) => {
                if (this.commandData && this.tmpData)
                    this.commandData[field] = this.tmpData[field]
            })
            this.tmpData = null
            this.i3pService.setEditMode(true)
        },
    },
}
</script>

<template>
    <div>
        <div v-if="commandData && !i3pService.isSaving" class="">
            <!-- border-s-md pl-2 border-primary" -->
            <v-row v-if="!i3pService.editMode" class="mb-2">
                <v-col cols="1" class="pr-0">
                    <v-btn
                        icon="mdi-chevron-left" variant="text" size="small" :disabled="!previousKey"
                        aria-label="Précédent"
                        @click="showEntity(previousKey)"
                    />
                </v-col>
                <v-col>
                    <div class="text-h5 text-center">
                        Visualiser une commande <span
                            class="text-subtitle-2 pl-2 text-medium-emphasis"
                        >{{ commandData.id }}</span>
                    </div>
                </v-col>
                <v-col cols="1" class="pl-0">
                    <v-btn
                        icon="mdi-chevron-right" variant="text" size="small" :disabled="!nextKey"
                        aria-label="Suivant"
                        @click="showEntity(nextKey)"
                    />
                </v-col>
            </v-row>
            <template v-if="entity">
                <div v-if="!i3pService.editMode" class="mb-2">
                    <v-btn
                        v-if="commandData && $permissionCheck(`majic_command_update`) && commandData.meta.editable"
                        class="mr-4 mb-2" variant="flat" prepend-icon="mdi-pencil" size="small" color="primary"
                        @click="setEditMode(true)"
                    >
                        Modifier
                    </v-btn>

                    <v-btn
                        v-if="commandData && $permissionCheck(`majic_command_update`) && commandData.meta.renewable"
                        class="mr-4 mb-2" variant="flat" prepend-icon="mdi-refresh" size="small" color="primary"
                        @click="i3pService.renewCommand(commandData)"
                    >
                        Renouveler
                    </v-btn>

                    <ListDeleteConfirmation
                        v-if="commandData && $permissionCheck(`majic_command_destroy`) && commandData.meta.deletable"
                        :item="commandData"
                        :translation-name="entity.translationKey"
                        button="<v-btn class='mr-4 mb-2' variant='outlined' prepend-icon='mdi-delete' size='small' color='primary'>Supprimer</v-btn>"
                        @delete-data="deleteEntity"
                    />

                    <v-btn
                        class="mr-4 mb-2" variant="text" prepend-icon="mdi-link-variant" size="small" color="primary"
                        @click="copyEntityLink"
                    >
                        Copier le lien
                    </v-btn>
                </div>
                <!-- // SHOW LOADER OON entity.loaded -->
                <EntityGlobalInfo
                    :data="commandData"
                    :i3p-service
                    :entity
                    @update-data="updateData($event)"
                    @save="saveEntity"
                />

                <CommuneSelector
                    :data="commandData"
                    :i3p-service
                    :validation="entity.getVuelidations()"
                    :validation-rules="entity.getRules()"
                    :translation-name="entity.translationKey"
                    @update-data="updateData($event)"
                />

                <EntityDownloadFile
                    :data="commandData"
                    :i3p-service
                    :entity
                />

                <EntityHistorique
                    v-if="!i3pService.editMode"
                    :data="commandData"
                    :entity
                />
            </template>
        </div>
        <template v-else>
            <div v-if="dataIsEmpty" class="h-screen">
                <div class="text-h5 text-center">
                    Aucun objet sélectionné
                </div>
            </div>
            <div v-else class="h-screen">
                <v-skeleton-loader type="article" />
                <v-skeleton-loader type="paragraph" />
                <v-skeleton-loader type="paragraph" />
            </div>
        </template>
    </div>
</template>
